


export const GET_FLIGHTS__REQUEST="GET_FLIGHTS__REQUEST";

export const GET_FLIGHTS__SUCCESS="GET_FLIGHTS__SUCCESS";

export const GET_FLIGHTS__FAILURE="GET_FLIGHTS__FAILURE";


